import { useCheckPermissionsArray } from "@/shared";
import SaveInventariable from "../../componente/SaveInventarible";
import { PermissionsEnum } from "@/auth/interfaces";

export default function CreateInventariablePage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_producto,
    PermissionsEnum.api_change_producto
  ]);

  return (
    <SaveInventariable titlePage="Crear Producto" />
  )

}